export enum LeadingTypes {
    // Treat leading configuration as a percentage of the external leading calculated from the font between baselines
    EXTERNAL_LEADING_PCT = 'EXTERNAL_LEADING_PCT',
    // Treat leading as a percentage of font size between baselines
    LEADING_PCT = 'LEADING_PCT',
}
